import React from 'react';
import { DateMonth } from './DateFormat';
import { connect } from 'react-redux';
import { OpenOldInvoicesPage } from './InvoiceLoginTypeHandler';
import { TAB_ENUM } from '../../../Page/SelfCarePage/Constant';
import { Tab } from 'react-bootstrap';

const SingleInvoice = (props) => {
  const invoicesList = props.data;
  const invoice = invoicesList[0]?.invoices[0];
  const description = invoice?.description;
  const billDate = invoice?.billDate;
  const billAmount = invoice?.billAmount;
  const displayAccountType = invoicesList[0]?.accountType === 'Business';
  const loginObj = props.loginObj;
  const invoicesOldPageUrl = props.invoicesOldPageUrl;
  const displayEnergyInvoiceValue = props.worldType === TAB_ENUM.Energy ? true : false;
  const displayButton = displayEnergyInvoiceValue ? 'display-button' : '';
  const displayAccountTypeClass = displayAccountType ? 'display-account-type' : '';

  const mainAmount = billAmount?.mainAmount?.replace("(-)", "-").replace(' ', '').trim();
  const subAmount = billAmount?.subAmount;
  const formattedAmount = `${mainAmount}.${subAmount}`;

  const reverseDescription = (description) => {
    if (!description) return '';
    return description.split(' + ').reverse().join(' + ');
  };

  return (
    <div className='single-invoices-container'>
      <div className={`invoice-box ${displayButton}`} onClick={() => props.openInvoiceIframe(invoice?.billUrl, invoice?.invoiceSourceType, invoicesList[0]?.banPsId, invoice?.id)}>
        <div className='invoice-details'>
          <div className='right-details'>
          {displayAccountType && (
            <div className='account-type-container'>
              <div className={invoicesList[0]?.accountType === 'Business' ? 'business' : invoicesList[0]?.accountType === 'Private' ? 'private' : ''}>
                {invoicesList[0]?.accountType === 'Business' ? 'עסקי' : ''}
              </div>
            </div>
          )}

            <div className={`description ${displayAccountTypeClass}`}>{reverseDescription(description)}</div>
            <div className="billDate">{billDate ? DateMonth(billDate) : ''}</div>
          </div>

          <div className='left-details'>
            <div className="price">
              <span className='text'>{formattedAmount}</span>
              <span> &#8362; </span>
              <div className='arrow'></div>
            </div>
          </div>
        </div>
      </div>

      {displayEnergyInvoiceValue ? (
        <>
          <div className='invoices-button-container' onClick={() => props.openOldInvoicesPage()}>
            <div className='button'>
              לכל החשבוניות
            </div>
            <div className='arrow-container'>
              <div className='arrow'></div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
    worldType: state.selfcarePage.epiData.worldType,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleInvoice);
